import {Injectable, TemplateRef} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({providedIn: 'root'})
export class ToastService {
    //declare variables
    toasts: any[] = [];
    private onShowEmitter$: Subject<{ textOrTpl: string | TemplateRef<any>, strHeader, strIcon, options: any }> = new Subject<{ textOrTpl: string | TemplateRef<any>; strHeader; strIcon; options: any }>()
    private onCancelEmitter$: Subject<boolean>;
    
    //inject services
    constructor() {
        this.onCancelEmitter$ = new Subject<boolean>();
    }

    //adds a toast to the array to show
    show(textOrTpl: string | TemplateRef<any>, strHeader, strIcon, options: any = {}) {
        this.onCancelEmitter$.next(true);
        this.toasts.push({textOrTpl, strHeader, strIcon, ...options});
        this.onShowEmitter$.next({textOrTpl, strHeader, strIcon, options});
    }
    
    //removes the toast from the array (hides)
    remove(toast) {
        this.toasts = this.toasts.filter(t => t != toast);
    }

    //remove all toasts
    removeAll() {
        this.toasts = [];
    }

    //subscribe to toasts
    subscribe(next: (value: { textOrTpl: string | TemplateRef<any>, strHeader, strIcon, options: any }) => void) {
        this.onShowEmitter$.subscribe(next);
    }

    //cancel toast subscription
    subscribeToCancel(next: (value: boolean) => void) {
        this.onCancelEmitter$.subscribe(next);
    }
}

